import React from 'react';
import { TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';

const PRAccountAssignmentTab = ({ masterData, currentItem, activeItemIndex, handleItemChange }) => (
  <TabsContent value="account">
    <Card>
      <CardHeader>
        <CardTitle>Item {currentItem?.item_number} - Account Assignment</CardTitle>
        <CardDescription>Cost allocation and account assignment</CardDescription>
      </CardHeader>
      <CardContent>
        {currentItem && (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label>Account Assignment Category *</Label>
                <select
                  value={currentItem.account_assignment_category}
                  onChange={(e) => handleItemChange(activeItemIndex, 'account_assignment_category', e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
                  required
                >
                  <option value="">Select</option>
                  {masterData.accountAssignmentCategories.map((aac) => (
                    <option key={aac.account_assignment_category_id} value={aac.account_assignment_category_id}>
                      {aac.account_assignment_category_id} - {aac.description}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <Label>G/L Account {['K', 'A'].includes(currentItem.account_assignment_category) ? '*' : ''}</Label>
                <select
                  value={currentItem.gl_account}
                  onChange={(e) => handleItemChange(activeItemIndex, 'gl_account', e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
                  required={['K', 'A'].includes(currentItem.account_assignment_category)}
                >
                  <option value="">Select G/L Account</option>
                  {masterData.glAccounts.map((gl) => (
                    <option key={gl.gl_account} value={gl.gl_account}>{gl.gl_account} - {gl.description}</option>
                  ))}
                </select>
              </div>

              <div>
                <Label>Controlling Area</Label>
                <select
                  value={currentItem.co_area}
                  onChange={(e) => handleItemChange(activeItemIndex, 'co_area', e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
                >
                  <option value="">Select CO Area</option>
                  {masterData.controllingAreas.map((ca) => (
                    <option key={ca.controlling_area_id} value={ca.controlling_area_id}>{ca.controlling_area_id} - {ca.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <Label>Profit Center</Label>
                <select
                  value={currentItem.profit_center}
                  onChange={(e) => handleItemChange(activeItemIndex, 'profit_center', e.target.value)}
                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
                >
                  <option value="">Select Profit Center</option>
                  {masterData.profitCenters.map((pc) => (
                    <option key={pc.profit_center_id} value={pc.profit_center_id}>{pc.profit_center_id} - {pc.name}</option>
                  ))}
                </select>
              </div>

              {currentItem.account_assignment_category === 'K' && (
                <div>
                  <Label>Cost Center *</Label>
                  <select
                    value={currentItem.cost_center}
                    onChange={(e) => handleItemChange(activeItemIndex, 'cost_center', e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md text-sm"
                    required
                  >
                    <option value="">Select Cost Center</option>
                    {masterData.costCenters.map((cc) => (
                      <option key={cc.cost_center_id} value={cc.cost_center_id}>{cc.cost_center_id} - {cc.name}</option>
                    ))}
                  </select>
                </div>
              )}

              {currentItem.account_assignment_category === 'A' && (
                <div>
                  <Label>Asset Number *</Label>
                  <Input value={currentItem.asset_number} onChange={(e) => handleItemChange(activeItemIndex, 'asset_number', e.target.value)} maxLength={12} placeholder="Asset number" required />
                </div>
              )}

              {currentItem.account_assignment_category === 'F' && (
                <div>
                  <Label>Order Number *</Label>
                  <Input value={currentItem.order_number} onChange={(e) => handleItemChange(activeItemIndex, 'order_number', e.target.value)} maxLength={12} placeholder="Internal order" required />
                </div>
              )}

              {currentItem.account_assignment_category === 'P' && (
                <div>
                  <Label>WBS Element *</Label>
                  <Input value={currentItem.wbs_element} onChange={(e) => handleItemChange(activeItemIndex, 'wbs_element', e.target.value)} maxLength={24} placeholder="WBS element" required />
                </div>
              )}
            </div>

            <div className="bg-orange-50 p-4 rounded-md">
              <h4 className="text-sm font-semibold text-orange-900 mb-2">Account Assignment Rules:</h4>
              <ul className="text-sm text-orange-800 space-y-1">
                <li><strong>K (Cost Center):</strong> Cost Center and G/L Account are mandatory</li>
                <li><strong>A (Asset):</strong> Asset Number and G/L Account are mandatory</li>
                <li><strong>F (Order):</strong> Order Number is mandatory</li>
                <li><strong>P (Project/WBS):</strong> WBS Element is mandatory</li>
                <li><strong>U (Multiple):</strong> G/L Account is mandatory, others optional for split</li>
              </ul>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  </TabsContent>
);

export default PRAccountAssignmentTab;
